import { FC, PropsWithChildren } from 'react';

export const CustomTableComponent: FC<PropsWithChildren> = ({ children }) => (
  <div className="w-full overflow-x-auto my-3 rounded-lg border border-gray-200 shadow-sm">
    <table className="w-max min-w-full divide-y divide-gray-200 text-sm">
      {children}
    </table>
  </div>
);

export const CustomTableHeadComponent: FC<PropsWithChildren> = ({
  children,
}) => <thead className="bg-gray-50">{children}</thead>;

export const CustomTableBodyComponent: FC<PropsWithChildren> = ({
  children,
}) => <tbody className="bg-white divide-y divide-gray-200">{children}</tbody>;

export const CustomTableRowComponent: FC<PropsWithChildren> = ({
  children,
}) => (
  <tr className="hover:bg-gray-50 transition-colors duration-150">
    {children}
  </tr>
);

export const CustomTableHeaderCellComponent: FC<PropsWithChildren> = ({
  children,
}) => (
  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider border-b border-gray-200 max-w-xs break-words">
    {children}
  </th>
);

export const CustomTableDataCellComponent: FC<PropsWithChildren> = ({
  children,
}) => (
  <td className="px-4 py-3 text-sm text-gray-900 max-w-xs break-words">
    {children}
  </td>
);
